module.exports = __webpack_public_path__ + "img/arrow-right.a5c1f824.svg";